import React from "react"

import { ProgramContainer } from "src/entities/formTemplateDataType";
import { LaborFooter } from "./LaborFooter";
import { getEnvVar } from "../config/RuntimeConfig";
import EHSPartnerPortalFooter from "./EHSPartnerPortalFooter";

interface Props {
  programContainer: ProgramContainer;
  isEng: boolean;
  callbackStepIndex?: (stepIndex: number) => void;
}
interface State {
  loginUser: any;
}

export class RuntimeFooterComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      loginUser: null
    }
  }

  componentDidMount(): void {
    if (this.props.programContainer?.FooterType === 'BXP') {
      this.getSessionInfo();
    }
  }
  // Get base URL path
  getPathBaseUrl = () => {
    if (getEnvVar('BXP_UI_BASE_PATH')) {
      try {
        return new URL(getEnvVar('BXP_UI_BASE_PATH')).origin;
      } catch (e) {}
    }
    return window.location.origin;
  } 

  //call https://dev.business.ontario.ca/home/api/auth/session to get session info
  getSessionInfo = async () => {
    //get url from current window
    const baseUrl = this.getPathBaseUrl();
    const sessionUrl = `${baseUrl}/home/api/auth/session`;
    try {
      const response = await fetch(sessionUrl);
      if (!response.ok) {
        return;
      }
      const sessionInfo = await response.json();
      this.setState({ loginUser: sessionInfo?.user || null });
    } catch (error) {
      console.error("Error fetching session info:", error);
    }
  }

  generateFooterString = () => {
    if (this.props.programContainer?.FooterType === 'CXP') {
      return (
        <footer className='ontario-footer ontario-footer--default'>
          <div className='ontario-row'>
            <nav className='ontario-columns ontario-small-12' aria-label="footer">
              <ul className='ontario-footer__links-container ontario-footer__links-container--inline'>
                <li><a className='ontario-footer__link' href={this.props.isEng? 'https://www.ontario.ca/page/about-ontario':'https://www.ontario.ca/fr/page/lontario-en-bref'}>{this.props.isEng? 'About Ontario' : 'L\'Ontario en bref'}</a></li>
                <li><a className='ontario-footer__link' href={this.props.isEng? 'https://www.ontario.ca/page/accessibility':'https://www.ontario.ca/fr/page/accessibilite'}>{this.props.isEng? 'Accessibility' : 'Accessibilité'}</a></li>
                <li><a className='ontario-footer__link' href={this.props.isEng? 'https://news.ontario.ca/newsroom/en':'https://news.ontario.ca/newsroom/fr'}>{this.props.isEng? 'News' : 'Nouvelles'}</a></li>
                <li><a className='ontario-footer__link' href={this.props.isEng ?'https://www.ontario.ca/page/privacy-statement':'https://www.ontario.ca/fr/page/declaration-concernant-la-protection-de-la-vie-privee'}>{this.props.isEng ? 'Privacy' : 'Confidentialité'}</a></li>
                <li><a className='ontario-footer__link' href={this.props.isEng ?'https://www.ontario.ca/page/terms-use':'https://www.ontario.ca/fr/page/conditions-dutilisation'}>{this.props.isEng ? 'Terms of Use' : "Condition d’utilisation"}</a></li>
              </ul>
              <div className='ontario-footer__copyright'>
                <a className='ontario-footer__link' href='https://www.ontario.ca/page/copyright-information'>{this.props.isEng ? "© King's Printer for Ontario," : "© Imprimeur du Roi pour l’Ontario,"}
                  <span className='ontario-nbsp'> 2026</span></a>
              </div>
            </nav>
          </div>
        </footer>
      );
    }
        if (this.props.programContainer?.FooterType === 'BXP') {
          return (
            <footer className="ontario-footer ontario-footer--default">
              <div className="ontario-row">
                <nav
                  className="ontario-columns ontario-small-12"
                  aria-label="footer"
                >
                  <ul className="ontario-footer__links-container ontario-footer__links-container--inline">
                    <li>
                      <a
                        className="ontario-footer__link"
                        href={
                          this.props.isEng
                            ? "https://www.ontario.ca/page/accessibility"
                            : "https://www.ontario.ca/fr/page/accessibilite"
                        }
                      >
                        {this.props.isEng ? "Accessibility" : "Accessibilité"}
                      </a>
                    </li>
                    <li>
                      <a
                        className="ontario-footer__link"
                        href={
                          this.props.isEng
                            ? "https://www.ontario.ca/page/privacy-statement"
                            : "https://www.ontario.ca/fr/page/declaration-concernant-la-protection-de-la-vie-privee"
                        }
                      >
                        {this.props.isEng ? "Privacy" : "Vie privée"}
                      </a>
                    </li>
                    <li>
                      <a
                        className="ontario-footer__link"
                        href={
                          this.props.isEng
                            ? "https://www.ontario.ca/feedback/contact-us"
                            : "https://www.ontario.ca/fr/commentaires/pour-nous-joindre"
                        }
                      >
                        {this.props.isEng
                          ? "Contact us"
                          : "Contactez-nous"}
                      </a>
                    </li>
                  {this.state.loginUser &&
                    Object.keys(this.state.loginUser).length > 0 && (
                      <li>
                        <a
                          className="ontario-footer__link"
                          href={
                            this.props.isEng
                              ? `${this.getPathBaseUrl()}/home/welcome/help-centre`
                              : `${this.getPathBaseUrl()}/home/welcome/help-centre`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {this.props.isEng
                            ? "Support Centre"
                            : "Centre d'aide"}
                        </a>
                      </li>
                    )}
                  </ul>
                  <div className="ontario-footer__copyright">
                    <a
                      className="ontario-footer__link"
                      href="https://www.ontario.ca/page/copyright-information"
                    >
                      {this.props.isEng
                        ? "© King's Printer for Ontario,"
                        : "© Imprimeur du Roi pour l’Ontario,"}
                      <span className="ontario-nbsp"> 2026</span>
                    </a>
                  </div>
                </nav>
              </div>
            </footer>
          );
        }
    if (this.props.programContainer?.FooterType === 'MOL') {
      return (
        <LaborFooter programContainer={this.props.programContainer} isEng={this.props.isEng} callbackStepIndex={(stepIndex)=>{
          this.props.callbackStepIndex(stepIndex);
        }}  />
      )
    }

    if (this.props.programContainer?.FooterType === 'EHSPartnerPortal') {
      return (
        <EHSPartnerPortalFooter programContainer={this.props.programContainer} callbackStepIndex={(stepIndex)=>{
          this.props.callbackStepIndex(stepIndex);
        }}  />
      )
    }

    if (this.props.programContainer?.CategoryId === 'CMA') {
      return (<footer className='ontario-footer ontario-footer--default'>
        <div className='ontario-row'>
          <nav className='ontario-columns ontario-small-12' aria-label="footer">
            <ul className='ontario-footer__links-container ontario-footer__links-container--inline'>
              <li><a className='ontario-footer__link' href={this.props.isEng? 'https://www.ontario.ca/page/accessibility':'https://www.ontario.ca/fr/page/accessibilite'}>{this.props.isEng? 'Accessibility' : 'Accessibilité'}</a></li>
              <li><a className='ontario-footer__link' href={this.props.isEng ?'https://www.ontario.ca/page/privacy-statement':'https://www.ontario.ca/fr/page/declaration-concernant-la-protection-de-la-vie-privee'}>{this.props.isEng ? 'Privacy' : 'Confidentialité'}</a></li>
              <li><a className='ontario-footer__link' href={this.props.isEng ? 'https://www.ontario.ca/feedback/contact-us':'https://www.ontario.ca/fr/commentaires/pour-nous-joindre'}>{this.props.isEng ? 'Contact us' : 'Communiquez avec nous'}</a></li>
              <li><a className='ontario-footer__link' href={this.props.isEng ?'https://www.ontario.ca/page/terms-use':'https://www.ontario.ca/fr/page/conditions-dutilisation'}>{this.props.isEng ? 'Terms of Use' : "Condition d’utilisation"}</a></li>
            </ul>
            <div className='ontario-footer__copyright'>
              <a className='ontario-footer__link' href='https://www.ontario.ca/page/copyright-information'>{this.props.isEng ? "© King's Printer for Ontario," : "© Imprimeur du Roi pour l’Ontario,"}
                <span className='ontario-nbsp'> 2023 - 26</span></a>
            </div>
          </nav>
        </div>
      </footer>);
    }
    
    return (
      <footer className='ontario-footer ontario-footer--default'>
        <div className='ontario-row'>
          <nav className='ontario-columns ontario-small-12' aria-label="footer">
            <ul className='ontario-footer__links-container ontario-footer__links-container--inline'>
              <li><a className='ontario-footer__link' href={this.props.isEng? 'https://www.ontario.ca/page/accessibility':'https://www.ontario.ca/fr/page/accessibilite'}>{this.props.isEng? 'Accessibility' : 'Accessibilité'}</a></li>
              <li><a className='ontario-footer__link' href={this.props.isEng ?'https://www.ontario.ca/page/privacy-statement':'https://www.ontario.ca/fr/page/declaration-concernant-la-protection-de-la-vie-privee'}>{this.props.isEng ? 'Privacy' : 'Confidentialité'}</a></li>
              <li><a className='ontario-footer__link' href={this.props.isEng ? 'https://www.ontario.ca/feedback/contact-us':'https://www.ontario.ca/fr/commentaires/pour-nous-joindre'}>{this.props.isEng ? 'Contact us' : 'Communiquez avec nous'}</a></li>
              <li><a className='ontario-footer__link' href={this.props.isEng ?'https://www.ontario.ca/page/terms-use':'https://www.ontario.ca/fr/page/conditions-dutilisation'}>{this.props.isEng ? 'Terms of Use' : "Condition d’utilisation"}</a></li>
            </ul>
            <div className='ontario-footer__copyright'>
              <a className='ontario-footer__link' href='https://www.ontario.ca/page/copyright-information'>{this.props.isEng ? "© King's Printer for Ontario," : "© Imprimeur du Roi pour l’Ontario,"}
                <span className='ontario-nbsp'> 2026</span></a>
            </div>
          </nav>
        </div>
      </footer>
    )
  }

  render() {  
    return (
      <>
        {this.generateFooterString()}
      </>
    )
  }
}
